<template>
    <div class="stock-record-container">
        <!-- 筛选区域 -->
        <div class="filter-card">
            <el-form :inline="true" :model="searchForm" class="search-form" size="medium">
                <el-form-item label="仓库名称">
                    <el-select v-model="searchForm.warehouseId" placeholder="全部仓库">
                        <el-option label="全部仓库" value=""></el-option>
                        <!-- 仅渲染子仓数据 -->
                        <el-option v-for="warehouse in warehouseList" :key="warehouse.houseId"
                            :label="warehouse.houseName" :value="warehouse.houseId"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 隐藏操作类型筛选框（如需显示则固定为出库） -->
                <!-- <el-form-item label="操作类型">
                    <el-select v-model="searchForm.operateType" placeholder="出库" disabled>
                        <el-option label="出库" value="out"></el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item label="食材名称/编码">
                    <el-input v-model="searchForm.materialKeyword" placeholder="输入食材名称或编码" clearable></el-input>
                </el-form-item>

                <el-form-item label="操作时间">
                    <el-date-picker v-model="searchForm.timeRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        clearable></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getRecordList">查询</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 记录列表 -->
        <div class="record-table-card">
            <el-table :data="recordList" border style="width: 100%" :header-cell-class-name="'table-header'"
                @row-click="handleRowClick" ref="table" height="63vh">
                <el-table-column label="序号" type="index" width="80" align="center" />
                <el-table-column prop="numId" label="流水号" align="center" width="180" />
                <el-table-column prop="productName" label="食材名称" align="center" width="180" />
                <el-table-column prop="shelfLife" label="保质期" align="center" width="120" />
                <el-table-column prop="untilExpiration" label="临期时间" align="center" width="120" />

                <!-- 固定显示出库标识（如需展示则打开） -->
                <!-- <el-table-column label="操作类型" align="center" width="120">
                    <template #default="scope">
                        <el-tag type="warning">出库</el-tag>
                    </template>
</el-table-column> -->

                <el-table-column prop="vendors" label="供应商" align="center" width="120" />
                <el-table-column prop="num" label="出库量" align="center" width="120" />
                <el-table-column prop="unit" label="单位" align="center" width="150" />
                <el-table-column prop="base64Data" label="食材图片" align="center" width="150">
                    <template #default="scope">
                        <el-image :src="scope.row.base64Data || 'https://picsum.photos/id/139/200/200'"
                            :preview-src-list="[scope.row.base64Data]" fit="cover"
                            style="width: 60px; height: 60px; border-radius: 4px" :alt="scope.row.productName + '图片'">
                            <div slot="error" class="image-error">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>

                <el-table-column prop="expiryDate" label="临期日期" align="center" width="150">
                    <template #default="scope">
                        <span
                            :class="scope.row.expiryDate ? (isExpired(scope.row.expiryDate) ? 'text-red-500 font-bold' : 'text-orange-500 font-bold') : ''">
                            {{ scope.row.expiryDate || '无' }}
                        </span>
                    </template>
                </el-table-column>

                <!-- 根据houseId匹配仓库名称显示 -->
                <el-table-column label="仓库名称" align="center" width="150">
                    <template #default="scope">
                        {{ getWarehouseNameById(scope.row.houseId) || '未知仓库' }}
                    </template>
                </el-table-column>

                <el-table-column prop="room" label="功能间" align="center" width="150" />
                <el-table-column prop="operator" label="操作人" align="center" width="120" />
                <el-table-column prop="dateTime" label="操作时间" align="center" width="200" />
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" v-if="total > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>

            <!-- 空数据提示 -->
            <div class="empty-tip" v-else>
                <el-empty description="暂无出库记录数据"></el-empty>
            </div>
        </div>
    </div>
</template>

<script>
import { getStoreOperation } from "@/api/record";
import { getHouseList, getHouseListByPid } from "@/api/terminal";

export default {
    name: 'WarehouseStockRecord',
    data() {
        return {
            // 搜索表单（强制默认出库类型）
            searchForm: {
                warehouseId: '',
                operateType: 'out', // 固定为出库
                materialKeyword: '',
                timeRange: [],
                operator: ''
            },
            // 仓库列表（仅存储子仓）
            warehouseList: [],
            // 全部原始数据（仅出库）
            allRecords: [],
            // 用于展示的当前页数据
            recordList: [],
            // 经过筛选后的总条数
            total: 0,
            currentPage: 1,
            pageSize: 10,
            // 详情弹窗
            detailVisible: false,
            currentRecord: null,
            // 加载状态
            loading: false
        }
    },
    mounted() {
        // 仅加载子仓列表，再加载出库记录数据
        this.loadSubWarehouseList().then(() => {
            this.getRecordList(true);
        });
    },
    methods: {
        /**
         * 仅加载子仓列表（过滤总仓）
         */
        async loadSubWarehouseList() {
            try {
                const params = {
                    userId: localStorage.getItem('userId'),
                    pid: null // 获取顶级仓库（总仓）
                };
                // 1. 获取所有总仓
                const mainWarehouseRes = await getHouseList(params);
                if (mainWarehouseRes && mainWarehouseRes.code === 200) {
                    const mainWarehouses = mainWarehouseRes.data || [];
                    // 2. 遍历总仓，获取每个总仓下的子仓（仅保留子仓）
                    const subWarehouseList = [];
                    for (const mainWarehouse of mainWarehouses) {
                        const subWarehouseRes = await getHouseListByPid({
                            userId: localStorage.getItem('userId'),
                            pid: mainWarehouse.houseId
                        });
                        if (subWarehouseRes && subWarehouseRes.code === 200) {
                            const subWarehouses = subWarehouseRes.data || [];
                            // 过滤掉可能混入的总仓（确保只存子仓）
                            const pureSubWarehouses = subWarehouses.filter(item => item.pid && item.pid !== item.houseId);
                            subWarehouseList.push(...pureSubWarehouses);
                        }
                    }
                    // 3. 仅将子仓赋值给仓库列表
                    this.warehouseList = subWarehouseList;
                }
            } catch (error) {
                console.error('加载子仓列表失败:', error);
                this.$message.error('子仓列表加载失败，将使用默认子仓数据');
                // 备用静态子仓数据（根据实际业务调整）
                this.warehouseList = [
                    { houseId: 101, houseName: '面食子仓-一区', pid: 1 },
                    { houseId: 102, houseName: '面食子仓-二区', pid: 1 },
                    { houseId: 201, houseName: '冷冻子仓-低温区', pid: 2 },
                    { houseId: 202, houseName: '冷冻子仓-常温区', pid: 2 },
                    { houseId: 301, houseName: '净菜子仓-清洗区', pid: 3 },
                    { houseId: 302, houseName: '净菜子仓-存储区', pid: 3 }
                ];
            }
        },

        /**
         * 根据仓库ID（houseId）获取仓库名称
         * @param {Number|String} houseId - 仓库ID
         * @returns {String} 仓库名称或空
         */
        getWarehouseNameById(houseId) {
            if (!houseId) return '';
            // 查找匹配的子仓（兼容数字/字符串ID）
            const warehouse = this.warehouseList.find(item =>
                item.houseId == houseId || item.houseId === String(houseId)
            );
            return warehouse ? warehouse.houseName : '';
        },

        /**
         * 获取出库记录列表（前端分页版本）
         * @param {boolean} forceRefresh - 是否强制从后端刷新数据
         */
        getRecordList(forceRefresh = false) {
            // 1. 如果需要强制刷新或首次加载，则从后端获取全部数据
            if (forceRefresh || this.allRecords.length === 0) {
                this.loading = true;
                const params = {
                    userId: localStorage.getItem('userId')
                };

                this.$message.info('正在加载出库数据...');
                getStoreOperation(params).then(res => {
                    this.loading = false;
                    if (res && res.code === 200) {
                        // 过滤出仅出库的数据（outFreezer !== '1' 为出库）
                        this.allRecords = (res.data || []).filter(record => record.outFreezer !== '1');
                        this.$message.success('出库数据加载成功');
                        // 数据加载完成后，调用内部方法进行筛选和分页
                        this.filterAndPaginate();
                    } else {
                        this.$message.error(res.message || '获取出库数据失败');
                        this.allRecords = [];
                        this.recordList = [];
                        this.total = 0;
                    }
                }).catch(error => {
                    this.loading = false;
                    console.error('API请求异常:', error);
                    this.$message.error('网络异常，请稍后重试');
                });
            } else {
                // 2. 否则，直接使用已有的 allRecords 进行筛选和分页
                this.filterAndPaginate();
            }
        },

        /**
         * 对出库记录进行筛选和分页，并更新 recordList 和 total
         */
        filterAndPaginate() {
            // 从仅出库的 allRecords 开始，进行筛选
            let filteredData = [...this.allRecords];

            // 筛选子仓（兼容houseId的数字/字符串格式）
            if (this.searchForm.warehouseId) {
                filteredData = filteredData.filter(record =>
                    record.houseId == this.searchForm.warehouseId ||
                    record.houseId === String(this.searchForm.warehouseId)
                );
            }

            // 强制过滤出库类型（双重保障）
            filteredData = filteredData.filter(record => record.outFreezer !== '1');

            // 筛选食材名称/编码
            if (this.searchForm.materialKeyword) {
                const keyword = this.searchForm.materialKeyword.toLowerCase();
                filteredData = filteredData.filter(record =>
                    (record.productName && record.productName.toLowerCase().includes(keyword)) ||
                    (record.materialName && record.materialName.toLowerCase().includes(keyword)) ||
                    (record.materialCode && record.materialCode.toLowerCase().includes(keyword)) ||
                    (record.numId && record.numId.toLowerCase().includes(keyword))
                );
            }

            // 筛选操作时间范围
            if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                const startTime = new Date(this.searchForm.timeRange[0]);
                const endTime = new Date(this.searchForm.timeRange[1]);
                endTime.setHours(23, 59, 59, 999); // 确保结束日期包含当天的所有时间

                filteredData = filteredData.filter(record => {
                    if (!record.dateTime) return false;
                    const recordTime = new Date(record.dateTime);
                    return recordTime >= startTime && recordTime <= endTime;
                });
            }

            // 更新总条数为筛选后的数据量
            this.total = filteredData.length;

            // 计算当前页的数据在筛选结果中的起始和结束索引
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;

            // 使用 slice 方法获取当前页的数据
            this.recordList = filteredData.slice(startIndex, endIndex);
        },

        /**
         * 重置搜索表单
         */
        resetSearch() {
            this.searchForm = {
                warehouseId: '',
                operateType: 'out', // 重置后仍固定为出库
                materialKeyword: '',
                timeRange: [],
                operator: ''
            };
            this.currentPage = 1;
            // 重置时强制从后端刷新数据
            this.getRecordList(true);
        },

        /**
         * 分页大小改变
         */
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 页码重置到第一页
            this.filterAndPaginate(); // 直接筛选分页，无需重新请求
        },

        /**
         * 当前页改变
         */
        handleCurrentChange(val) {
            this.currentPage = val;
            this.filterAndPaginate(); // 直接筛选分页，无需重新请求
        },

        /**
         * 查看详情
         */
        viewDetail(record) {
            this.currentRecord = { ...record };
            this.detailVisible = true;
        },

        /**
         * 判断是否过期
         */
        isExpired(expiryDate) {
            if (!expiryDate) return false;
            const today = new Date().setHours(0, 0, 0, 0);
            const expDate = new Date(expiryDate).setHours(0, 0, 0, 0);
            return expDate < today;
        },

        /**
         * 导出出库记录
         */
        exportRecords() {
            this.$message.info('导出功能已触发，正在生成出库记录Excel文件...');
            setTimeout(() => {
                this.$message.success('出库记录导出成功，已开始下载');
            }, 1500);
        },

        /**
         * 行点击选中
         */
        handleRowClick(row) {
            this.$refs.table?.toggleRowSelection(row);
            // 点击行时展示详情
            this.viewDetail(row);
        }
    }
}
</script>

<style lang="scss" scoped>
.stock-record-container {
    padding: 20px;
    background-color: #fafbfc;
    min-height: 100vh;
}

/* 页面标题 */
.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
        font-size: 18px;
        font-weight: 500;
        color: #1f2937;
        margin: 0;
    }

    .header-actions {
        display: flex;
        gap: 12px;
    }
}

/* 筛选卡片 */
.filter-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 16px;
    margin-bottom: 20px;
}

.search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
}

/* 记录表格卡片 */
.record-table-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 20px;
    height: 67vh;
}

.table-header {
    background-color: #f0f7ff !important;
    color: #1890ff;
    font-weight: 500;
}

/* 分页容器 */
.pagination-container {
    margin-top: 20px;
    text-align: right;
}

/* 空数据提示 */
.empty-tip {
    padding: 60px 0;
    text-align: center;
}

/* 详情弹窗样式 */
.detail-content {
    padding: 10px 0;
}

.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .record-no {
        font-size: 14px;
        color: #4b5563;
        font-weight: 500;
    }

    .operate-tag {
        margin-left: 16px;
    }
}

.detail-table {
    margin-bottom: 20px;

    el-table {
        margin-bottom: 12px;
    }
}

.detail-remark {
    h4 {
        font-size: 14px;
        color: #4b5563;
        margin-bottom: 8px;
        font-weight: 500;
    }

    p {
        font-size: 13px;
        color: #6b7280;
        line-height: 1.5;
        margin: 0;
    }
}

/* 文本颜色 */
.text-red-500 {
    color: #f56c6c;
}

.text-orange-500 {
    color: #e6a23c;
}

.text-blue-500 {
    color: #409eff;
}

.font-bold {
    font-weight: 500;
}

/* 弹窗底部按钮 */
.dialog-footer {
    text-align: right;
}

/* 图片错误占位 */
.image-error {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #8c939d;
    border-radius: 4px;
}
</style>